import { c as _c } from "react/compiler-runtime";
import type { SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';

/**
 * Page-owned title / description / canonical / robots / JSON-LD.
 *
 * A `<SEOMetadata>` rendered inside a page loses to `SEOProvider` (next/head keeps the last tag per
 * key, and the provider renders after the page). These props go through `ActiveContentContext` and
 * `SEOProvider` renders them last, so they win on the server render and after hydration.
 *
 * Pass `null` to set nothing (e.g. while the data that decides the props is loading).
 */
export function usePageSEO(seoProps) {
  const $ = _c(7);
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== seoProps) {
    t0 = seoProps ? JSON.stringify(seoProps) : "";
    $[0] = seoProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const key = t0;
  let t1;
  if ($[2] !== activeContent || $[3] !== seoProps) {
    t1 = () => {
      activeContent.setSeoProps(seoProps);
      return () => {
        activeContent.setSeoProps(null);
      };
    };
    $[2] = activeContent;
    $[3] = seoProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== key) {
    t2 = [key];
    $[5] = key;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useUniversalEffect(t1, t2);
}